let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lnlyc")).then(() => parcelRequire('2e4lT'));